import { Button, Form } from "devextreme-react";
import "./LogisticStatistics.scss";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { formatNumber } from "devextreme/localization";
import { displayPercent } from "../../../../../Helpers/utils/utils";
import { getLogisticsStatisticsRequest } from "../../../../../Backend/LogisticsRequests";
import { FormInput } from "../../../../../Components/Buttons/FormInput/FormInput";

export function LogisticStatistics({ onBack }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [dataSource, setDataSource] = useState();
  const [errorStats, setErrorStats] = useState(false);
  const [schoolNumber, setSchoolNumber] = useState();
  const [receiptDate, setReceiptDate] = useState();

  useEffect(() => {
    getLogisticStats();
  }, []);

  const getLogisticStats = async () => {
    setIsLoading(true);
    let params = {};
    if (
      schoolNumber !== "" &&
      schoolNumber !== undefined &&
      schoolNumber !== 0
    ) {
      params["school.SchoolNumber"] = schoolNumber;
    }

    if (receiptDate !== "" && receiptDate !== undefined && receiptDate !== 0) {
      params["receiptDate"] = receiptDate;
    }

    let resp = await getLogisticsStatisticsRequest(params);
    if (resp.success) {
      setDataSource(resp.data);
    } else {
      setErrorStats(true);
    }
    setIsLoading(false);
  };

  return (
    <div className="logistic-stats trans-fromTop">
      <div className="title">{t("LogisticStatistics")}</div>
      <div className="header-wrapper">
        <div className="filters-wrapper">
          <div className="input-wrapper">
            <span className="label">{t("SchoolNumber")}</span>
            <FormInput
              type="number"
              value={schoolNumber}
              change={(x) => setSchoolNumber(x)}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("ReceiptDate")}</span>
            <FormInput
              placeholder="YYYY-MM-DD"
              type="input"
              value={receiptDate}
              change={(x) => setReceiptDate(x)}
            />
          </div>
          <div className="button-wrapper">
            <Button
              onClick={() => getLogisticStats()}
              className="filter-button"
            >
              {t("ApplyFilters")}
            </Button>
          </div>
        </div>
        <div className="button-wrapper">
          <div onClick={onBack} className="button">
            arrow_back
          </div>
        </div>
      </div>
      {isLoading ? (
        <div className="loader-container">
          <div className="loader" />
        </div>
      ) : (
        <div className="chart-wrapper">
          {errorStats ? (
            <div className="column-wrapper">
              <div className="panel-wrapper-row">
                <div className="panel error">
                  <div className="icon">warning</div>
                  <div className="text">{t("ErrorLoadingLogisticStats")}</div>
                </div>
              </div>
            </div>
          ) : (
            <div className="column-wrapper">
              <div className="panel-wrapper-row">
                <div className="panel">
                  <div className="subtitle">{t("LinkedPackages")}</div>
                  <div className="value">
                    {formatNumber(dataSource.linkedPackages)}
                  </div>
                </div>
                <div className="panel">
                  <div className="subtitle">{t("LinkedPackagesStatus")}</div>
                  <div className="stats-row">
                    <div className="stats-column initial">
                      <div className="static-value">
                        {formatNumber(dataSource.autoLinkedPackages)}
                      </div>
                      <div className="hover-value">
                        {displayPercent(
                          (dataSource.autoLinkedPackages /
                            dataSource.linkedPackages) *
                            100
                        )}
                      </div>
                      <div className="text">{t("Automatic")}</div>
                    </div>
                    <div className="stats-column keeped">
                      <div className="static-value">
                        {formatNumber(dataSource.manuallyLinkedPackages)}
                      </div>
                      <div className="hover-value">
                        {displayPercent(
                          (dataSource.manuallyLinkedPackages /
                            dataSource.linkedPackages) *
                            100
                        )}
                      </div>
                      <div className="text">{t("Manual")}</div>
                    </div>
                  </div>
                </div>
                <div className="panel">
                  <div className="subtitle">{t("NotLinkedPackages")}</div>
                  <div className="value">
                    {formatNumber(dataSource.notLinkedPackages)}
                  </div>
                </div>
                <div className="panel">
                  <div className="subtitle">{t("NotLinkedPackagesStatus")}</div>
                  <div className="stats-row">
                    <div className="stats-column initial">
                      <div className="static-value">
                        {formatNumber(dataSource.extraNotLinkedPackages)}
                      </div>
                      <div className="hover-value">
                        {displayPercent(
                          (dataSource.extraNotLinkedPackages /
                            dataSource.notLinkedPackages) *
                            100
                        )}
                      </div>
                      <div className="text">{t("ExtraNotLinked")}</div>
                    </div>
                    <div className="stats-column keeped">
                      <div className="static-value">
                        {formatNumber(dataSource.cannotLinkPackages)}
                      </div>
                      <div className="hover-value">
                        {displayPercent(
                          (dataSource.cannotLinkPackages /
                            dataSource.notLinkedPackages) *
                            100
                        )}
                      </div>
                      <div className="text">{t("CannotLink")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
